import { gql } from '@apollo/client'

export default gql`
  fragment FullOneOffPayment on OneOffPayment {
    id
    comment
    paymentDate
    resultAmount
    status
    meetingId
    paymentDateValid
  }
`
